<template>
  <ul class="pagination">
    <slot></slot>
    <li class="pagination-item">
      <button
        type="button"
        @click="onClickFirstPage"
        :disabled="isInFirstPage"
        aria-label="Go to first page"
        class="btn-first"
      >
        First
      </button>
    </li>

    <li class="pagination-item">
      <button
        type="button"
        @click="onClickPreviousPage"
        :disabled="isInFirstPage"
        aria-label="Go to previous page"
        class="btn-previous"
        :class="{ 'disabled' : isInFirstPage }"
      >
        <span :class="previousName"></span>
      </button>
    </li>

    <li v-for="page in pages" class="pagination-item">
      <button
        type="button"
        @click="onClickPage(page.name)"
        :disabled="page.isDisabled"
        :class="{ active: isPageActive(page.name) }"
        :aria-label="`Go to page number ${page.name}`"
        class="btn-number-page"
      >
        {{ page.name }}
      </button>
    </li>

    <li class="pagination-item">
      <button
        type="button"
        @click="onClickNextPage"
        :disabled="isInLastPage"
        aria-label="Go to next page"
        class="btn-next"
        :class="{ 'disabled' : isInLastPage }"
      >
        <span :class="nextName"></span>
      </button>
    </li>

    <li class="pagination-item">
      <button
        type="button"
        @click="onClickLastPage"
        :disabled="isInLastPage"
        aria-label="Go to last page"
        class="btn-last"
      >
        Last
      </button>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'pagination',
    props: {
      nextName: {
        type: String,
        default: "Next"
      },
      previousName: {
        type: String,
        default: "Previous"
      },
      maxVisibleButtons: {
        type: Number,
        required: false,
        default: 3
      },
      totalPages: {
        type: Number,
        required: true
      },
      total: {
        type: Number,
        required: true
      },
      perPage: {
        type: Number,
        required: true
      },
      currentPage: {
        type: Number,
        required: true
      },
    },
    computed: {
      startPage() {
        if (this.currentPage === 1) {
          return 1;
        }

        if (this.currentPage === this.totalPages) {
          return this.totalPages - this.maxVisibleButtons + 1;
        }

        return this.currentPage - 1;

      },
      endPage() {

        return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);

      },
      pages() {
        const range = [];

        for (let i = this.startPage; i <= this.endPage; i+= 1 ) {
          range.push({
            name: i,
            isDisabled: i === this.currentPage
          });
        }

        return range;
      },
      isInFirstPage() {
        return this.currentPage === 1;
      },
      isInLastPage() {
        return this.currentPage === this.totalPages;
      },
    },
    methods: {
      onClickFirstPage() {
        this.$emit('pagechanged', 1);
      },
      onClickPreviousPage() {
        this.$emit('pagechanged', this.currentPage - 1);
      },
      onClickPage(page) {
        this.$emit('pagechanged', page);
      },
      onClickNextPage() {
        this.$emit('pagechanged', this.currentPage + 1);
      },
      onClickLastPage() {
        this.$emit('pagechanged', this.totalPages);
      },
      isPageActive(page) {
        return this.currentPage === page;
      },
    }
  }
</script>

<style scoped>
  .pagination {
    list-style-type: none;
  }

  .pagination-item {
    display: inline-block;
  }

  .active {
    background-color: #4AAE9B;
    color: #ffffff;
  }
  .nextArrow:after{
    content: "\00bb";
    position: relative;
    top: -2px;
  }
  .previousArrow:after{
    content: "\00ab";
    position: relative;
    top: -2px;
  }
  .nextText:after{
    content: "Next"
  }
  .previousText:after{
    content: "Previous"
  }
  .disabled{
    color: #cccccc !important;
  }






  .btn-first, .btn-last, .btn-number-page{
    display: none !important;
  }
  .btn-previous{
    background-color: #fff;
    border: 1px solid #ccc;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    width: 30px;
    color: #00a4e9;
  }
  .btn-next{
    background-color: #fff;
    border: 1px solid #ccc;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    width: 30px;
    color: #00a4e9;
  }
  .pagination{
    margin-right: 0.3rem;
  }
  .page{
    position: relative;
    top: .4rem;
    font-size: 14px;
    right: 0.5rem;
    color: #7b7b80;
    letter-spacing: 2px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue